export const ENV = {
    mode: 'Staging'
    , production: false
    , msalConfig: {
        auth: {
            clientId: 'f35c74e4-e762-4d43-9c7a-7f0f8df0f11d'
            , authority: 'https://login.microsoftonline.com/fe9c4641-3b53-43d0-af72-8f3e64d3aa05'
            , tenantId: 'fe9c4641-3b53-43d0-af72-8f3e64d3aa05'
        }
    }
    , apiConfig: {
        scopes: ['api://f35c74e4-e762-4d43-9c7a-7f0f8df0f11d/eos.api.access']
        , uri: '/api/*'
        , postLogoutRedirectUri: 'https://easyorderstg.dksh.com'
        , redirectUri: 'https://easyorderstg.dksh.com'
    }
    , unauthorizedConfig: {
        unauthorizedUrl: 'https://easyorderstg.dksh.com/#/unauthorized'
        , unauthorizedRedirect: 'https://easyorderstg.dksh.com'
    }
    , redirectConfig: {
        connectPlusUrl: 'https://uat.clm.euris.com/dksh-hc'
        , connectClientUrl: 'https://flpnwc-xlgtvarz5i.dispatcher.ap1.hana.ondemand.com'
    }
  }

// LOCAL HOST DEPLOYMENT
//   export const ENV = {
//     mode: 'Local'
//     , production: false
//     , msalConfig: {
//         auth: {
//             clientId: '367095ba-9c40-4244-91ab-4c2972d67aeb'
//             , authority: 'https://login.microsoftonline.com/fe9c4641-3b53-43d0-af72-8f3e64d3aa05'
//             , tenantId: 'fe9c4641-3b53-43d0-af72-8f3e64d3aa05'
//         }
//     }
//     , apiConfig: {
//         scopes: ['api://367095ba-9c40-4244-91ab-4c2972d67aeb/eos.api.access']
//         , uri: '/api/*'
//         , postLogoutRedirectUri: 'http://localhost:8100'
//         , redirectUri: 'http://localhost:8100'
//     }
//     , unauthorizedConfig: {
//         unauthorizedUrl: 'http://localhost:8100/#/unauthorized'
//         , unauthorizedRedirect: 'http://localhost:8100'
//     }
//     , redirectConfig: {
//         connectPlusUrl: 'https://uat.clm.euris.com/dksh-hc'
//         , connectClientUrl: 'https://flpnwc-xlgtvarz5i.dispatcher.ap1.hana.ondemand.com'
//     }
//   }


// WEBPACK FOOTER //
// ./src/environment/environment.ts